export const INVITE_ATTENDEES = 'app/DeedPage/InviteAttendeesOverlay/INVITE_ATTENDEES';
export const INVITE_ATTENDEES_SUCCESS =
  'app/DeedPage/InviteAttendeesOverlay/INVITE_ATTENDEES_SUCCESS';
export const INVITE_ATTENDEES_FAILED =
  'app/DeedPage/InviteAttendeesOverlay/INVITE_ATTENDEES_FAILED';

export const SEARCH = 'app/DeedPage/InviteAttendeesOverlay/SEARCH';
export const SEARCH_SUCCESS = 'app/DeedPage/InviteAttendeesOverlay/SEARCH_SUCCESS';
export const SEARCH_FAILED = 'app/DeedPage/InviteAttendeesOverlay/SEARCH_FAILED';

export const CLEAR = 'app/DeedPage/InviteAttendeesOverlay/CLEAR';
